import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import { t } from '@/plugins/i18n'
import { confirmEdit } from '@/util/useConfirm'


export default /*#__PURE__*/_defineComponent({
  props: ['account', 'accounts'],
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props


const cur = computed({
  get: () => props.account,
  set: (v) => {
    confirmEdit(
      () => { emit('update', v) },
      () => {}
    )
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: _unref(cur),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cur) ? (cur).value = $event : null))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.accounts, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v.customerId,
          value: v.customerId,
          label: v.loginName
        }, null, 8, ["value", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})